/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfDashboardData } from "../models/AjaxResponseOfDashboardData";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class DashboardAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfDashboardData
   * @throws ApiError
   */
  public dashboardInformation({
    vendorId,
  }: {
    vendorId?: number;
  }): CancelablePromise<AjaxResponseOfDashboardData> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/dashboard",
      query: {
        vendorId: vendorId,
      },
    });
  }
}
